import {
  GET_EXPENSES_REQUEST,
  GET_EXPENSES_SUCCESS,
  GET_EXPENSES_FAILURE,
  GET_EXPENSE_REQUEST,
  GET_EXPENSE_SUCCESS,
  GET_EXPENSE_FAILURE,
  CREATE_EXPENSE_REQUEST,
  CREATE_EXPENSE_SUCCESS,
  CREATE_EXPENSE_FAILURE,
  UPDATE_EXPENSE_REQUEST,
  UPDATE_EXPENSE_SUCCESS,
  UPDATE_EXPENSE_FAILURE,
  DELETE_EXPENSE_REQUEST,
  DELETE_EXPENSE_SUCCESS,
  DELETE_EXPENSE_FAILURE,
  SUBMIT_EXPENSE_REQUEST,
  SUBMIT_EXPENSE_SUCCESS,
  SUBMIT_EXPENSE_FAILURE,
  APPROVE_EXPENSE_REQUEST,
  APPROVE_EXPENSE_SUCCESS,
  APPROVE_EXPENSE_FAILURE,
  REJECT_EXPENSE_REQUEST,
  REJECT_EXPENSE_SUCCESS,
  REJECT_EXPENSE_FAILURE,
  GET_EXPENSE_STATS_REQUEST,
  GET_EXPENSE_STATS_SUCCESS,
  GET_EXPENSE_STATS_FAILURE
} from '../types';

const initialState = {
  expenses: [],
  currentExpense: null,
  stats: null,
  loading: false,
  error: null,
  pagination: {
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10
  }
};

const expenseReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Expenses
    case GET_EXPENSES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_EXPENSES_SUCCESS:
      return {
        ...state,
        loading: false,
        expenses: action.payload.data.expenses,
        pagination: action.payload.data.pagination,
        error: null
      };

    case GET_EXPENSES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Get Single Expense
    case GET_EXPENSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_EXPENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        currentExpense: action.payload.data,
        error: null
      };

    case GET_EXPENSE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Create Expense
    case CREATE_EXPENSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case CREATE_EXPENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        expenses: [action.payload.data, ...state.expenses],
        error: null
      };

    case CREATE_EXPENSE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Update Expense
    case UPDATE_EXPENSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case UPDATE_EXPENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        expenses: state.expenses.map(expense =>
          expense.id === action.payload.data.id ? action.payload.data : expense
        ),
        currentExpense: state.currentExpense?.id === action.payload.data.id 
          ? action.payload.data 
          : state.currentExpense,
        error: null
      };

    case UPDATE_EXPENSE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Delete Expense
    case DELETE_EXPENSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case DELETE_EXPENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        expenses: state.expenses.filter(expense => expense.id !== action.payload.id),
        currentExpense: state.currentExpense?.id === action.payload.id 
          ? null 
          : state.currentExpense,
        error: null
      };

    case DELETE_EXPENSE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Submit Expense
    case SUBMIT_EXPENSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case SUBMIT_EXPENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        expenses: state.expenses.map(expense =>
          expense.id === action.payload.data.id ? action.payload.data : expense
        ),
        currentExpense: state.currentExpense?.id === action.payload.data.id 
          ? action.payload.data 
          : state.currentExpense,
        error: null
      };

    case SUBMIT_EXPENSE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Approve Expense
    case APPROVE_EXPENSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case APPROVE_EXPENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        expenses: state.expenses.map(expense =>
          expense.id === action.payload.data.id ? action.payload.data : expense
        ),
        currentExpense: state.currentExpense?.id === action.payload.data.id 
          ? action.payload.data 
          : state.currentExpense,
        error: null
      };

    case APPROVE_EXPENSE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Reject Expense
    case REJECT_EXPENSE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case REJECT_EXPENSE_SUCCESS:
      return {
        ...state,
        loading: false,
        expenses: state.expenses.map(expense =>
          expense.id === action.payload.data.id ? action.payload.data : expense
        ),
        currentExpense: state.currentExpense?.id === action.payload.data.id 
          ? action.payload.data 
          : state.currentExpense,
        error: null
      };

    case REJECT_EXPENSE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Get Expense Stats
    case GET_EXPENSE_STATS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_EXPENSE_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        stats: action.payload.data,
        error: null
      };

    case GET_EXPENSE_STATS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default expenseReducer;
